"use strict";

exports.__esModule = true;
exports.themeIcons = void 0;
/*

  This file is generated by a script. To change it update the files:

    /src/themes/_icon-placeholder.css
    /src/themes/_base.css

  and the svg files in the folder:

    /src/icons/

  the svgs should be formated so that the only color is #000000
  and that the color is explicitly set where needed. Then run:

    npm run icons

  from the package root to regenerate this file.

*/

// eslint-disable-next-line import/prefer-default-export
var themeIcons = exports.themeIcons = ['Address', 'AnnualReport', 'ArrowLeft', 'Automatic', 'Bluetooth', 'Brochure', 'Cabin', 'Calculator', 'Calendar', 'Car', 'Charging', 'Chat', 'CheckWithBg', 'ChevronDown', 'ChevronLeft', 'ChevronRight', 'ChevronUp', 'CircleWithBoarder', 'Clock', 'Close', 'Co2', 'Cross', 'CrossThin', 'Dash', 'Electric', 'Engine', 'Facebook', 'Filter', 'FormError', 'FourWheelDrive', 'FuelAlt', 'Fuel', 'Laptop', 'Load', 'LocationFlag', 'LocationPin', 'Location', 'Lowcost', 'Map', 'MediaLibrary', 'Mobile', 'More', 'Offers', 'Pause', 'Play', 'Pointer', 'PressKit', 'Print', 'RedCheckmark', 'Sawc', 'Safety', 'Satnav', 'Seats', 'SlashRight', 'Sport', 'SteeringWheel', 'Tick', 'Tooltip', 'Towing', 'TradeIn', 'Turning', 'Twitter', 'Upload', 'ViewMore', 'Warning', 'Wheel', 'ArrowLeftBig', 'Download', 'Email', 'FacebookSquare', 'Instagram', 'Linkedin', 'Phone', 'PinMarker', 'Pinterest', 'Search', 'Youtube'];